import * as S from './style';

function ThirdGradient() {
    return (
        <S.ThirdGradient xmlns="http://www.w3.org/2000/svg" width="1385" height="1377" viewBox="0 0 1385 1377" fill="none">
            <g filter="url(#filter0_f_451_2054)">
                <path fillRule="evenodd" clipRule="evenodd" d="M750.241 300.883C483.432 1142 162.847 999.798 268.757 412.078H415.488C34.953 1338.26 737.184 1292.56 1085 300.883H750.241Z" fill="url(#paint0_linear_451_2054)" fillOpacity="0.48"/>
            </g>
            <defs>
                <filter id="filter0_f_451_2054" x="-52" y="0.882812" width="1437" height="1376" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                    <feGaussianBlur stdDeviation="150" result="effect1_foregroundBlur_451_2054"/>
                </filter>
                <linearGradient id="paint0_linear_451_2054" x1="248" y1="1076.88" x2="248" y2="300.883" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#00AAFF"/>
                    <stop offset="0.5" stopColor="#1DD59F"/>
                    <stop offset="1" stopColor="#39FF3F"/>
                </linearGradient>
            </defs>
        </S.ThirdGradient>
    )
}

export default ThirdGradient;